import {BranchOffice, City, RegionType, SubCityType, WoredaType, ZoneType} from './CommonModels';

export class UserDto {
    id : number;
    firstName : string;
    lastName : string;
    username : string;
    email: string;
    phone : string;
    fullName : string;
    branchOffice : BranchOffice;
    branchOfficeId: number;
    profession: string;
    applicantType: LookupDto;
    applicantTypeId: number;
    roles : LookupDto[];
    departments: LookupDto[];
    address: AddressDto;
    hasUserDetail: boolean;
    userType: LookupDto;
    isFaydaVerified: boolean;
    faydaPsut: string;

    constructor() {
        this.address = new AddressDto();
        this.roles = [];
        this.departments = [];
    }
}

export class AddressDto {
    regionId: number;
    zoneId: number;
    subCityId: number;
    woredaId: number;
    cityId: number;
    region : RegionType;
    woreda : WoredaType;
    zone : ZoneType;
    kebele : string;
    city : City;
    houseNo : string;  
    subCity: SubCityType;

    setFormData(address) {
        this.region = new RegionType();
        this.regionId = this.region.id = address.controls.region.value;
        this.zone = new ZoneType();
        this.zoneId = this.zone.id = address.controls.zone.value;
        this.woreda = new WoredaType();
        this.woredaId = this.woreda.id = address.controls.woreda.value;
        this.kebele = address.controls.kebele.value;
        if(address.controls.city.value) {
            this.city = new City();
            this.cityId = this.city.id = address.controls.city.value;
        }
        this.houseNo = address.controls.houseNumber.value;
        if(address.controls.subCity.value) {
            this.subCity = new SubCityType();
            this.subCityId = this.subCity.id = address.controls.subCity.value;
        }
    }
}

export class LookupDto {
    id: number;
    name: string;
    code: string;

    constructor(id : number, name : string, code: string) {
        this.id = id;
        this.name = name;
        this.code = code;
    }
}
  
export class vwUser {
    id : number;
    firstName : string;
    lastName : string;
    username : string;
    email: string;
    phone : string;
    roleID : number[];
    addressID : number;
    roleName : string;
    branchOfficeName : string;
    branchOfficeID : string;
    activated: string;
    fullName: string;
}

export class MenuConfiguration {
    parentMenuID: number;
    name: string;
    url: string;
    icon: string;
    priority: number;
    menuCode: string;
    childMenus: MenuConfiguration[];
    id: number;
    isActive: boolean;
    createdDate: string;
    modifiedDate: string;
    rowGuid: string;
    isExpanded: boolean;
}  

export class Role{
    id: number;
    name: string;
    roleCode : string;
    users?: UserDto[];
}